<template>
  <div class="chaton-whatsappsidepopup chaton-chat"
   :class="{
     'chaton-whatsapp-rtl' : isRtl, 
     'chaton-layout-one': chatonLayout == 'layout1',
     'chaton-layout-overlay' : isShowWidget & enableResponsiveClass & chatonLayout == 'layout1',
     'chaton-whatsappside-responsive' : enableResponsiveClass & chatonLayout == 'layout1'
    }" >
    <div class="chaton-chatsidebar_float chaton-widgetclose chaton-users-list" >
      <div class="chaton-chat_previewfloat">
        <div class="chaton-chat_sidebar">
            <whatsapp-users-list />
        </div>
        <responsive-chat-box v-if="isResponsiveChat && Object.keys(chatInfo).length && chatonLayout == 'layout2'" />
      </div>
    </div>
    <div class="chaton-chatfloatholder" :class="{'chaton-floatholdertwo': chatonLayout == 'layout2'}">
      <whatsapp-chat-box v-if="enableWhatsappWidgetBox"/>
      <div v-if="chatonLayout == 'layout2'" class="chaton-chatfloat chaton-layouttwo">
        <span>
            <a v-if="chatonLayout == 'layout2'" @click.prevent="showChatWidget()" href="javascript:void(0);" id="chaton-whatsappchatopen" class="chaton-whatsapp_chat">
                <i v-if="isShowWidget" class="chatonicon chaton-x"></i>
                <template v-else>
                    <img :src="floatingIcon" v-if="floatingIcon" alt="" class="chaton-float-icon"/>
                    <whatsapp-image :ImageColor="'white'" v-else />
                </template>
            </a>
          </span>
      </div>
      <div v-else  @click.prevent="showChatWidget()" class="chaton-needchat chaton-whatsapp_chat" id="chaton-whatsappchatopen">
        <whatsapp-image :ImageColor="'white'" />
        <h6>{{TRANS.layout2_btn_txt}}</h6>
      </div>
    </div>
  </div>
</template>

<script>
import jQuery                     from "jquery";
import WhatsappImage              from "./WhatsappUsers/WhatsappImage.vue";
import { mapState }               from 'vuex';
import ResponsiveChatBox          from "./ResponsiveChatBox/ResponsiveChatBox.vue";
import WidgetChatBox              from "./WidgetChatBox/WidgetChatBox.vue";
import WhatsappUsersList  from "./WhatsappUsers/WhatsappUsersList.vue";
const CHATON_SETTINGS           = window.chaton_scripts_vars.chatSetting;
export default {
  name: 'App',
  components: {
    WhatsappImage,
    ResponsiveChatBox,
    whatsappChatBox   : WidgetChatBox,
    WhatsappUsersList
  },
  data(){
    return {
      isRtl                   : false,
      isShowWidget            : false,
      floatingIcon            : CHATON_SETTINGS.floatingIcon,
      isMobileDevice          : CHATON_SETTINGS.isMobileDevice,
      openWidget              : false,
      chatonLayout            : CHATON_SETTINGS.chatonLayout,
      enableResponsiveClass         : '',
    }
  },
  computed:{
    enableWhatsappWidgetBox(){
        let chatInfo = new Object();
        if(!this.$store.state.isResponsiveChat || CHATON_SETTINGS.chatonLayout == 'layout1'){
            chatInfo = this.$store.getters.getChatInfo;
        }
        return Object.keys(chatInfo).length ? true : false;
    },
    ...mapState({
      isResponsiveChat : (state) => state.isResponsiveChat,
      isMobileView    : (state) => state.isMobileView,
    }),
    chatInfo(){
      return this.$store.getters.getChatInfo;
    },
    css: function(){
      return "<style> :root { --themewhatsappcolor: " + CHATON_SETTINGS.primaryColor+ "; --secwhatsappcolor: " + CHATON_SETTINGS.secondaryColor + "; --terwhatsappcolor: " + CHATON_SETTINGS.textColor + "; } </style>"
    },
  },
  methods:{
    whatsappAddClass(){
      let width = jQuery('.chaton-chat').width();
      if ( width <= 768){
        this.enableResponsiveClass = true;
        jQuery('.chaton-whatsappsidepopup').addClass('chaton-whatsappside-responsive');
        jQuery(document).on("click",'.chaton-whatsappsidepopup .conversation-list .chaton-whatsappsidepopup .user-list .chaton-btn-respond',function() {
          jQuery('.chaton-chat').addClass("chaton-opnchatbox")
        });
      }
      jQuery(document).on("click",'.chaton-backtolist',function() {
        jQuery('.chaton-chat').removeClass('chaton-opnchatbox')
      });
    },
    timeout(ms){
       return new Promise(resolve => setTimeout(resolve, ms));
    },
    async showChatWidget(){
      jQuery('.chaton-floatdropdownholder').hide();
      jQuery('.chaton-chatsidebar_float').toggleClass('chaton-widgetclose');
      let width = jQuery('.chaton-chat').width();
      let delayTime = this.chatonLayout == 'layout1' ? 50 : 150;

      if(this.isShowWidget){
        await this.timeout(delayTime);
        this.isShowWidget = false;
        jQuery('.chaton-users-list .conversation-list').removeClass('active');
      }else{
        this.isShowWidget = true;
        let containerId= document.getElementById('chaton_conv_list');
        if (containerId) {
          containerId.scrollTop = 0;
        }

        jQuery('.chaton-users-list .conversation-list').addClass('active');
      }

      if(this.isMobileDevice){
        if(this.isShowWidget){
          jQuery('html').css('overflow','hidden');
        }else {
          jQuery('html').css('overflow','');
        }
      }
      if ( width <= 768 ){
        let isResponsiveChat = this.isShowWidget ? true : false;
        this.$store.commit('updateWidgetType', { isResponsiveChat });
      }
    },
  },
  created(){
    jQuery('head').prepend(this.css);
    let windowWidth =  jQuery( window ).width();
    if( windowWidth < 768 ) {
      this.$store.commit('updateWidgetType', { isMobileView : true });
    }
    this.isRtl = CHATON_SETTINGS.isRtl;
    this.$store.commit('updateWindowWidth',{ windowWidth });
  },
  mounted(){
    this.whatsappAddClass();
    this.$root.$on('showWidget',()=>{
      this.showChatWidget();
    })
  },
}
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&family=Urbanist:wght@400;500;700&display=swap");
:root {--primchatfont: "Urbanist", sans-serif; }
:root {--secchatfont: "Open Sans", sans-serif; }
:root {--whatsapp-fontcolor: #25D366; }
.chaton-chat h1,
.chaton-chat h2,
.chaton-chat h3,
.chaton-chat h4,
.chaton-chat h5,
.chaton-chat h6 {
  font-weight: 700;
  font-family: var(--primchatfont);
  color: var(--secguppycolor);
}
*,
*::after,
*::before {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}
.chaton-chat_sidebar {
  height: 100%;
  flex: 0 0 100%;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  -ms-flex: 0 0 100%;
  -webkit-box-flex: 0;
  box-shadow: 0 0 30px 0 rgb(0 0 0 / 10%);
}
.chaton-chat *::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.chaton-chat *::-webkit-scrollbar-thumb {
  visibility: hidden;
  opacity: 0;
  border-radius: 60px;
  background-color: var(--themewhatsappcolor);
  border: 5px solid var(--themewhatsappcolor);
}
.chaton-chat *:hover::-webkit-scrollbar-thumb {
  visibility: visible;
  opacity: 1;
}
.chaton-chat .chaton-form-control,
.chaton-chat input[type=text],
.chaton-chat input[type=password],
.chaton-chat input[type=datetime],
.chaton-chat input[type=datetime-local],
.chaton-chat input[type=date],
.chaton-chat input[type=month],
.chaton-chat input[type=time],
.chaton-chat input[type=week],
.chaton-chat input[type=number],
.chaton-chat input[type=email],
.chaton-chat input[type=url],
.chaton-chat input[type=search],
.chaton-chat input[type=tel],
.chaton-chat input[type=color],
.chaton-chat select,
.uneditable-input {
  outline: none !important;
    padding: 0 20px;
    height: 40px;
    color: var(--secwhatsappcolor);
    font: 16px/26px var(--secchatfont);
    border-radius: 3px;
    background-clip: unset;
    caret-color: var(--secwhatsappcolor);
    letter-spacing: 0.01em;
    width: 100%;
    border: 1px solid #ddd;
    margin: 0;
    background-color: #fff !important;
    box-shadow: none;
    font-weight: 400 !important;
}
.chaton-chat input[type=text]::placeholder,
.chaton-chat input[type=password]::placeholder,
.chaton-chat input[type=datetime]::placeholder,
.chaton-chat input[type=datetime-local]::placeholder,
.chaton-chat input[type=date]::placeholder,
.chaton-chat input[type=month]::placeholder,
.chaton-chat input[type=time]::placeholder,
.chaton-chat input[type=week]::placeholder,
.chaton-chat input[type=number]::placeholder,
.chaton-chat input[type=email]::placeholder,
.chaton-chat input[type=url]::placeholder,
.chaton-chat input[type=search]::placeholder,
.chaton-chat input[type=tel]::placeholder,
.chaton-chat input[type=color]::placeholder,
.chaton-chat .chaton-form-control::placeholder {
  font-size: 14px;
  font-weight: 400 !important;
  color: var(--terwhatsappcolor) !important;
}

.chaton-chat .chaton-sidebarhead_search .chaton-form-group input {
    font-size: 14px;
    padding-left: 45px;
    width: 100%;
    height: 40px;
    border-radius: 3px;
}

.chaton-replay_msg textarea.chaton-form-control {
    resize: none;
    height: 40px !important;
    font-size: 15px;
    padding-top: 6px;
    padding-bottom: 6px;
    max-height: 40px;
    overflow: auto !important;
}

.chaton-chatfloatholder {
    position: fixed;
    bottom: 44px;
    right: 44px;
    z-index: 10000;
}

.chaton-widgetclose.chaton-chatsidebar_float{
    opacity: 0;
    visibility: hidden;
    transition: all .3s ease-in-out;
    top: 50% !important;
}
.chaton-chatsidebar_float {
  bottom: 0;
  right: 20px;
  opacity: 1;
  width: 100%;
  z-index: 999;
  height: 100%;
  display: block;
  position: fixed;
  max-width: 480px;
  transform: scale(1);
  visibility: visible;
  background-color: #fff;
  transition: all .3s ease-in-out;
}
.chaton-chat_previewfloat {
  width: 100%;
  height: 100%;
}
.chaton-whatsapp_chat {
  background-color: var(--themewhatsappcolor) !important;
}
.chaton-chatfloat > span {
  position: relative;
  z-index: 1;
  display: block;
  border-radius: 50%;
  box-shadow: -2px 4px 10px rgba(0, 0, 0, 0.24);
}
.chaton-chatfloat > span a {
  align-items: center;
  justify-content: center;
  background: #FFF;
  line-height: 1;
  width: 58px;
  height: 58px;
  border-radius: 60px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.chaton-chatfloat > span a img,
.chaton-chatfloat > span a svg {
  display: block;
  max-width: 26px;
}
.chaton-chatfloat > span a .chaton-float-icon{
    max-width: 73px;
    border-radius: 50%;
    height: 73px;
}
.chaton-chatfloat > span a i{
  color: var(--terwhatsappcolor);
  font-size: 25px;
}
.chaton-chatsidebar_float:not(.chaton-widgetclose) + .chaton-chatfloatholder .chaton-chatfloat {
  opacity: 0;
  height: 30px;
  display: none;
  visibility: hidden;
}
.chaton-whatsappside-responsive .chaton-chatsidebar_float {
  max-width: 540px;
}
.chaton-whatsappside-responsive.chaton-opnchatbox .chaton-chat_sidebar {
  display: none !important;
}

@media(max-width:1280px){
  .chaton-chatsidebar_float{
    max-width: 400px;
  }
  .chaton-floatchat{
    right: 420px;
  }
  .chaton-floatchat + .chaton-floatchat {
    right: 790px;
  }
}
@media (max-width: 991px){
  .chaton-chatsidebar_float {
    max-width: 380px;
  }
  .chaton-floatchat {
    right: 395px;
  }
}

/* rtl styling */
.chaton-whatsapp-rtl .chaton-chatfloatholder {
  right: auto;
  left: 44px;
}
.chaton-whatsapp-rtl .chaton-chatsidebar_float {
  right: auto;
  left: 0;
}
.chaton-whatsapp-rtl .chaton-sidebarhead > a {
  margin-left: 0;
  padding-right: 20px;
  padding-left: 0;
  margin-right: auto;
}
.chaton-whatsapp-rtl .chaton-sidebarhead_search .chaton-form-group i {
  left: auto;
  right: 18px;
}
.chaton-whatsapp-rtl.chaton-chat .chaton-sidebarhead_search .chaton-form-group input {
  padding-right: 45px;
  padding-left: 20px;
}
.chaton-whatsapp-rtl .chaton-userbar_right {
  margin-left: 0;
  margin-right: auto;
  padding-right: 10px;
  padding-left: 0;
}
.chaton-whatsapp-rtl .chaton-userbar_profile + .chaton-userbar_title {
  margin-right: 15px;
  margin-left: 0;
}
.chaton-whatsapp-rtl .chaton-userbar_profile .chaton-userstatus{
  left: 0;
  right: auto;
}
.chaton-whatsapp-rtl .chaton-whatsappbtn svg {
  margin-right: 0;
  margin-left: 10px;
}
.chaton-whatsapp-rtl .chaton-floatchat {
  right: auto;
  left: 500px;
}

.chaton-whatsapp-rtl .chaton-widgetclose ~ .chaton-chatfloatholder .chaton-floatchat {
  right: auto;
  left: 165px;
}
.chaton-whatsapp-rtl .chaton-floatchat_title figure {
  margin-right: 0;
  margin-left: 10px;
}
.chaton-whatsapp-rtl .chaton-singleimg .chaton-userstatus {
  right: auto;
  left: -3px;
}
.chaton-whatsapp-rtl .chaton-floatchat_title-right {
  margin-right: auto;
  margin-left: 0;
}
.chaton-whatsapp-rtl .chaton-send {
  margin-left: 0;
  margin-right: 10px;
}

</style>